export const paths = {
	case: (accountNodeId: number, caseObjectName: string) => `/accounts/${accountNodeId}/cases/${caseObjectName}`,
};
